/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MessageEntityTypeEnum = "contacts" | "containers" | "shipments" | "voyages" | "%future added value";
export type SendMessageDialogFormQueryVariables = {
    entityType: MessageEntityTypeEnum;
    entitySlug: string;
    templateSlug?: string | null;
    bodyContentFilter?: Array<string> | null;
};
export type SendMessageDialogFormQueryResponse = {
    readonly messageForm: {
        readonly entityType: MessageEntityTypeEnum;
        readonly entitySlug: string;
        readonly templateSlug: string;
        readonly defaultLanguage: string;
        readonly messages: ReadonlyArray<{
            readonly language: string;
            readonly languageTitle: string;
            readonly subject: string;
            readonly to: ReadonlyArray<string>;
            readonly roles: ReadonlyArray<string>;
            readonly body: string;
            readonly attachments: ReadonlyArray<string> | null;
            readonly subjectParams: ReadonlyArray<string>;
            readonly bodyParams: ReadonlyArray<string>;
            readonly signature: string | null;
        }>;
        readonly possibleTemplates: ReadonlyArray<{
            readonly title: string;
            readonly slug: string;
        }>;
        readonly possibleReceivers: ReadonlyArray<{
            readonly contactId: string | null;
            readonly contactNumber: string;
            readonly contactType: string;
            readonly roles: ReadonlyArray<string>;
            readonly name: string;
            readonly group: string;
        }>;
        readonly attachmentFolderSets: ReadonlyArray<{
            readonly folders: ReadonlyArray<{
                readonly slug: string;
                readonly name: string;
                readonly attachments: ReadonlyArray<{
                    readonly attachmentSlug: string;
                    readonly " $fragmentRefs": FragmentRefs<"EntityAttachmentListPreviewer_attachment" | "EntityAttachment_attachment">;
                }>;
            }>;
        }>;
        readonly " $fragmentRefs": FragmentRefs<"AttachmentSelectionDialog_messageForm">;
    } | null;
};
export type SendMessageDialogFormQuery = {
    readonly response: SendMessageDialogFormQueryResponse;
    readonly variables: SendMessageDialogFormQueryVariables;
};



/*
query SendMessageDialogFormQuery(
  $entityType: MessageEntityTypeEnum!
  $entitySlug: String!
  $templateSlug: String
  $bodyContentFilter: [String!]
) {
  messageForm(entityType: $entityType, entitySlug: $entitySlug, templateSlug: $templateSlug, bodyContentFilter: $bodyContentFilter) {
    entityType
    entitySlug
    templateSlug
    defaultLanguage
    messages {
      language
      languageTitle
      subject
      to
      roles
      body
      attachments
      subjectParams
      bodyParams
      signature
    }
    possibleTemplates {
      title
      slug
    }
    possibleReceivers {
      contactId
      contactNumber
      contactType
      roles
      name
      group
    }
    attachmentFolderSets {
      folders {
        slug
        name
        attachments {
          attachmentSlug
          ...EntityAttachmentListPreviewer_attachment
          ...EntityAttachment_attachment
          id
        }
        id
      }
    }
    ...AttachmentSelectionDialog_messageForm
  }
}

fragment AttachmentSelectionDialog_messageForm on MessageFormResponse {
  attachmentFolderSets {
    key
    title
    folders {
      slug
      entitySlug
      name
      attachments {
        attachmentSlug
        ...EntityAttachment_attachment
        id
      }
      id
    }
  }
}

fragment EntityAttachmentListPreviewer_attachment on EntityAttachment {
  url
  downloadUrl
  name
  contentType
  previewUrl
  documentType
  entityType
  entitySlug
  attachmentSlug
  thumbnailImage
  ...EntityAttachmentRoleVisibility_attachment
}

fragment EntityAttachmentRoleVisibility_attachment on EntityAttachment {
  name
  attachmentSlug
  entityType
  entitySlug
  roleVisibilities {
    role
    roleShortTitle
    roleTitle
    visible
  }
}

fragment EntityAttachment_attachment on EntityAttachment {
  url
  downloadUrl
  name
  contentType
  previewUrl
  documentType
  draftTicketStatus
  lexOfficeInvoiceStatus
  signedStatus
  rejectReason
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bodyContentFilter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entitySlug"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateSlug"
},
v4 = [
  {
    "kind": "Variable",
    "name": "bodyContentFilter",
    "variableName": "bodyContentFilter"
  },
  {
    "kind": "Variable",
    "name": "entitySlug",
    "variableName": "entitySlug"
  },
  {
    "kind": "Variable",
    "name": "entityType",
    "variableName": "entityType"
  },
  {
    "kind": "Variable",
    "name": "templateSlug",
    "variableName": "templateSlug"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entitySlug",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateSlug",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultLanguage",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roles",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "MessageFormContent",
  "kind": "LinkedField",
  "name": "messages",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "languageTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "to",
      "storageKey": null
    },
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attachments",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subjectParams",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bodyParams",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signature",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "MessagePossibleTemplate",
  "kind": "LinkedField",
  "name": "possibleTemplates",
  "plural": true,
  "selections": [
    (v11/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "MessagePossibleReceiver",
  "kind": "LinkedField",
  "name": "possibleReceivers",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactType",
      "storageKey": null
    },
    (v9/*: any*/),
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "group",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attachmentSlug",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SendMessageDialogFormQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "MessageFormResponse",
        "kind": "LinkedField",
        "name": "messageForm",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v10/*: any*/),
          (v13/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageFolderSet",
            "kind": "LinkedField",
            "name": "attachmentFolderSets",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Folder",
                "kind": "LinkedField",
                "name": "folders",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EntityAttachment",
                    "kind": "LinkedField",
                    "name": "attachments",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "EntityAttachmentListPreviewer_attachment"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "EntityAttachment_attachment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AttachmentSelectionDialog_messageForm"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SendMessageDialogFormQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "MessageFormResponse",
        "kind": "LinkedField",
        "name": "messageForm",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v10/*: any*/),
          (v13/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageFolderSet",
            "kind": "LinkedField",
            "name": "attachmentFolderSets",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Folder",
                "kind": "LinkedField",
                "name": "folders",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EntityAttachment",
                    "kind": "LinkedField",
                    "name": "attachments",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "downloadUrl",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contentType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "previewUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "documentType",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "thumbnailImage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoleVisibility",
                        "kind": "LinkedField",
                        "name": "roleVisibilities",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "roleShortTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "roleTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "visible",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "draftTicketStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lexOfficeInvoiceStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "signedStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rejectReason",
                        "storageKey": null
                      },
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "98428c7366e4dac9bd1d1b96e461f8e4",
    "id": null,
    "metadata": {},
    "name": "SendMessageDialogFormQuery",
    "operationKind": "query",
    "text": "query SendMessageDialogFormQuery(\n  $entityType: MessageEntityTypeEnum!\n  $entitySlug: String!\n  $templateSlug: String\n  $bodyContentFilter: [String!]\n) {\n  messageForm(entityType: $entityType, entitySlug: $entitySlug, templateSlug: $templateSlug, bodyContentFilter: $bodyContentFilter) {\n    entityType\n    entitySlug\n    templateSlug\n    defaultLanguage\n    messages {\n      language\n      languageTitle\n      subject\n      to\n      roles\n      body\n      attachments\n      subjectParams\n      bodyParams\n      signature\n    }\n    possibleTemplates {\n      title\n      slug\n    }\n    possibleReceivers {\n      contactId\n      contactNumber\n      contactType\n      roles\n      name\n      group\n    }\n    attachmentFolderSets {\n      folders {\n        slug\n        name\n        attachments {\n          attachmentSlug\n          ...EntityAttachmentListPreviewer_attachment\n          ...EntityAttachment_attachment\n          id\n        }\n        id\n      }\n    }\n    ...AttachmentSelectionDialog_messageForm\n  }\n}\n\nfragment AttachmentSelectionDialog_messageForm on MessageFormResponse {\n  attachmentFolderSets {\n    key\n    title\n    folders {\n      slug\n      entitySlug\n      name\n      attachments {\n        attachmentSlug\n        ...EntityAttachment_attachment\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment EntityAttachmentListPreviewer_attachment on EntityAttachment {\n  url\n  downloadUrl\n  name\n  contentType\n  previewUrl\n  documentType\n  entityType\n  entitySlug\n  attachmentSlug\n  thumbnailImage\n  ...EntityAttachmentRoleVisibility_attachment\n}\n\nfragment EntityAttachmentRoleVisibility_attachment on EntityAttachment {\n  name\n  attachmentSlug\n  entityType\n  entitySlug\n  roleVisibilities {\n    role\n    roleShortTitle\n    roleTitle\n    visible\n  }\n}\n\nfragment EntityAttachment_attachment on EntityAttachment {\n  url\n  downloadUrl\n  name\n  contentType\n  previewUrl\n  documentType\n  draftTicketStatus\n  lexOfficeInvoiceStatus\n  signedStatus\n  rejectReason\n}\n"
  }
};
})();
(node as any).hash = '8656c9e32162be54a9260abea0b94a63';
export default node;
